import React from "react";
import Switch from "react-switch";

const ActiveMenu = ({ id, active, title_active, handleMenu }) => {
  return (
    <Switch
      onChange={() => handleMenu(id, active, title_active)}
      checked={active === 1}
      className="react-switch md:ml-0"
      uncheckedIcon={
        <div
          style={{
            display: "flex",
            alignItems: "center",
            height: "100%",
            fontSize: 12,
            color: "white",
            justifyContent: "center",
          }}
        >
          
        </div>
      }
      checkedIcon={
        <div
          style={{
            display: "flex",
            alignItems: "center",
            height: "100%",
            fontSize: 12,
            color: "white",
            justifyContent: "center",
          }}
        >
          
        </div>
      }
      width={30}
      height={15}
      handleDiameter={10}
      offColor="#E53E3E" // Red for inactive
      onColor="#38A169" // Green for active
    />
  );
};

export default ActiveMenu;
